import { SearchResponse } from '@/core/types/response'

/**
 * Server-side cap of the paginated GET list endpoints (PaginationQueryDto). Selectors
 * that need "all" of a user's networks or meeting links request this many.
 */
export const LIST_ENDPOINT_MAX_LIMIT = 100

/**
 * Normalizes a list endpoint response: tolerates the legacy bare-array shape (so the
 * frontend can deploy ahead of the backend pagination flip) and, in development, flags
 * a silently truncated list so the caller raises its limit or paginates.
 */
export function toSearchResponse<M>(response: M[] | SearchResponse<M>, endpoint: string, isDev = import.meta.env.DEV): SearchResponse<M> {
  const normalized = Array.isArray(response) ? { items: response, totalCount: response.length } : response
  if (isDev && normalized.totalCount > normalized.items.length) {
    console.warn(`[${endpoint}] list truncated to ${normalized.items.length} of ${normalized.totalCount} items: raise the limit or paginate.`)
  }
  return normalized
}
